'use strict';

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _lodash = _interopRequireDefault(require("lodash"));

var _formInputField = _interopRequireDefault(require("./../form-input-field"));

require("whatwg-fetch");

var _fetchUtils = _interopRequireDefault(require("./../../fetchUtils"));

var _translate = _interopRequireDefault(require("../translate"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

var FarmComment = /*#__PURE__*/function (_React$Component) {
  _inherits(FarmComment, _React$Component);

  function FarmComment(props) {
    var _this;

    _classCallCheck(this, FarmComment);

    _this = _possibleConstructorReturn(this, (FarmComment.__proto__ || Object.getPrototypeOf(FarmComment)).call(this, props));
    _this.state = {
      isLoading: false,
      isEditMode: false,
      data: {
        id: 0,
        comment: ''
      },
      loadedData: {}
    };
    _this.renderEditMode = _this.renderEditMode.bind(_assertThisInitialized(_this));
    _this.renderAddbutton = _this.renderAddbutton.bind(_assertThisInitialized(_this));
    _this.updateInput = _this.updateInput.bind(_assertThisInitialized(_this));
    _this.storeComment = _this.storeComment.bind(_assertThisInitialized(_this));
    _this.cancel = _this.cancel.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(FarmComment, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;

      this.setState({
        isLoading: true
      });
      fetch("/api/farms/".concat(this.props.id, "/comment"), {
        credentials: 'include'
      }).then(_fetchUtils.default.checkStatus).then(function (result) {
        _this2.setState(function (prev) {
          prev.data.id = result.id;
          prev.data.comment = result.comment;
          prev.loadedData = _lodash.default.cloneDeep(prev.data);
          return prev;
        });
      }).catch(function (err) {
        if (err.error.status !== 404) void 0;
      }).then(function () {
        _this2.setState({
          isLoading: false
        });
      });
    }
  }, {
    key: "updateInput",
    value: function updateInput(e) {
      e.preventDefault();
      var value = e.target.value;
      this.setState(function (prev) {
        prev.data.comment = value;
        return prev;
      });
    }
  }, {
    key: "storeComment",
    value: function storeComment() {
      var _this3 = this;

      this.setState({
        isLoading: true
      });
      fetch("/api/farms/".concat(this.props.id, "/comment"), {
        credentials: 'include',
        method: this.state.data.id ? 'PUT' : 'POST',
        body: JSON.stringify(this.state.data),
        headers: {
          'Content-Type': 'application/json'
        }
      }).then(_fetchUtils.default.checkStatus).then(function (result) {
        _this3.setState(function (prev) {
          prev.isEditMode = false;
          prev.data.id = parseInt(result.id);
          prev.data.comment = result.comment;
          prev.loadedData = _lodash.default.cloneDeep(prev.data);
          return prev;
        });
      }).catch(function (err) {
        void 0;
      }).then(function () {
        _this3.setState({
          isLoading: false
        });
      });
    }
  }, {
    key: "cancel",
    value: function cancel() {
      this.setState(function (prev) {
        prev.data = _lodash.default.cloneDeep(prev.loadedData);
        prev.isEditMode = false;
        return prev;
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this4 = this;

      var t = this.props.t;
      if (this.state.isLoading) return this.renderLoading();
      if (this.state.isEditMode) return this.renderEditMode();
      if (!this.state.data.id || this.state.data.comment.trim() === '') return this.renderAddbutton();
      return /*#__PURE__*/_react.default.createElement("div", {
        className: "comp-farm-comment",
        onClick: function onClick() {
          return _this4.setState({
            isEditMode: true
          });
        },
        title: t('click to edit')
      }, /*#__PURE__*/_react.default.createElement("h2", null, t('comment')), /*#__PURE__*/_react.default.createElement("p", null, this.state.data.comment.split('\n').map(function (item, key) {
        return /*#__PURE__*/_react.default.createElement("span", {
          key: key
        }, item, /*#__PURE__*/_react.default.createElement("br", null));
      })));
    }
  }, {
    key: "renderLoading",
    value: function renderLoading() {
      return /*#__PURE__*/_react.default.createElement("div", {
        className: "datalist__loader"
      }, this.props.t('loading data'), /*#__PURE__*/_react.default.createElement("span", {
        className: "loader"
      }));
    }
  }, {
    key: "renderEditMode",
    value: function renderEditMode() {
      return /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(_formInputField.default, {
        type: _formInputField.default.component.constants.TEXTAREA,
        name: "comment",
        label: this.props.t('comment'),
        onChange: this.updateInput,
        isEditable: true,
        value: this.state.data.comment
      }), /*#__PURE__*/_react.default.createElement("div", {
        className: "button-group"
      }, /*#__PURE__*/_react.default.createElement("button", {
        className: "btn",
        onClick: this.storeComment
      }, this.props.t('save')), /*#__PURE__*/_react.default.createElement("button", {
        className: "btn btn--secondary",
        onClick: this.cancel
      }, this.props.t('cancel'))));
    }
  }, {
    key: "renderAddbutton",
    value: function renderAddbutton() {
      var _this5 = this;

      return /*#__PURE__*/_react.default.createElement("button", {
        className: "btn",
        onClick: function onClick() {
          _this5.setState({
            isEditMode: true
          });
        }
      }, this.props.t('Add comment'));
    }
  }]);

  return FarmComment;
}(_react.default.Component);

FarmComment.propTypes = {
  id: _propTypes.default.number.isRequired,
  t: _propTypes.default.func.isRequired
};

var _default = (0, _translate.default)(FarmComment);

exports.default = _default;


//////////////////
// WEBPACK FOOTER
// ./client/components/farm-comment/index.js
// module id = 47
// module chunks = 0